module.exports = __webpack_public_path__ + "img/saltstack.0a67eac7.png";